import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { Observable, Subscription } from 'rxjs';
import { CodePostalDto, ParcDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-code-postal-select',
  templateUrl: './code-postal-select.component.html',
  styleUrls: ['./code-postal-select.component.css']
})
export class CodePostalSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.codesPostaux$) codesPostaux$: Observable<CodePostalDto[]>;
  @Select(ControlPanelStore.codesPostauxAcceptes$) codesPostauxAcceptes$: Observable<CodePostalDto[]>;
  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;

  @Input('width') width: number;

  @Input() codePostalId: number;
  @Input() onlyAccepted: boolean = false;
  @Input() onlyParcs: boolean = false;

  @Output() codePostalIdChange = new EventEmitter<number>();

  @Input() cell: any;
  @Input() datagrid: DxDataGridComponent;
  @Input() disabled: boolean = false;

  InitId = null;

  CodesPostaux: CodePostalDto[] = [];
  ColumnName = [];

  cp: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'PostalCode',
        'Locality',
      ]
      ).subscribe(translations => {
        this.ColumnName.push(translations['PostalCode']);
        this.ColumnName.push(translations['Locality']);
      });
  }

  ngOnInit() {
    if(this.codePostalId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.codePostalId));
    }

    if (this.onlyParcs) {
      this.cp = this.parcs$.subscribe(res => {
        if (res != null) {
          this.CodesPostaux = res
            .filter(value => value.EstActif)
            .map(r => ({ Id: r.CodePostalId, Code: r.CodePostalCode, Localite: r.CodePostalLocalite, NomAffiche: r.CodePostalCode + ' - ' + r.CodePostalLocalite }))
            .filter((value, index, self) => index === self.findIndex((t) => (t.Id === value.Id)));
        }
      });
    }
    else if (this.onlyAccepted) {
      this.cp = this.codesPostauxAcceptes$.subscribe(res => {
        if (res != null) {
          this.CodesPostaux = res;
        }
      });
    } else {
      this.cp = this.codesPostaux$.subscribe(res => {
        if (res != null) {
          this.CodesPostaux = res;
        }
      });
    }
  }

  ngOnDestroy() {
    this.cp?.unsubscribe();
  }

  updateInfo(event) {
    this.codePostalId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.codePostalId;
    if (!!this.datagrid && this.InitId != this.codePostalId) {
      const store: CustomStore = this.datagrid.instance.getDataSource().store();
      const key = this.cell.data[store.key()];
      if (key != null) {
        store.update(key, { codePostalId: this.codePostalId}).then(_result => {
          this.datagrid.instance.refresh();
        });
      }
      if (event.currentSelectedRowKeys.length == 1) {
        //console.log('-->', event.currentSelectedRowKeys[0]);
        this.cell.data['CodePostalCode'] = event.currentSelectedRowKeys[0].Code;
        this.cell.data['CodePostalLocalite'] = event.currentSelectedRowKeys[0].Localite;
      }
    }
    this.codePostalIdChange.emit(this.codePostalId);

    if(this.codePostalId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.codePostalId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}

